<template>
    <section class="ui-graph-bars" :style="heightCss">
        <div class="graphic-body">
            <div v-if="max" class="rows">
                <div v-for="(value, index) in rows" :key="index"><span>{{value}}</span></div>
            </div>
            <div v-if="data.length > 1" class="bars">
                <div v-for="(item, index) in data" :key="index">
                    <span :style="setHeightCss(item.v)"/>
                    <div :style="setBottomCss(item.v)">{{item.v}}</div>
                </div>
            </div>
        </div>
        <div v-if="labels.length && max" class="graphic-footer">
            <div v-for="(label, index) in labels" :key="index">{{label}}</div>
        </div>
        <div v-if="load" class="load-info">
            <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8"/>
        </div>

        <div v-if="!max && !load" class="no-data">
            <span>Nenhuma informação para ser exibida.</span>
        </div>
    </section>
</template>


<script>
    import { uiLoadIndicator } from '@/components/ui'
    export default {
        name: 'graphic-bars',

		components: { uiLoadIndicator },

        props:{
            data: {
                type: Array,
                required: true,
            },
            labels: {
                type: Array,
                required: true,
            },
            h: {
                type: Number,
                required: true,
            },
            load: {
                type: Boolean,
                required: false,
            },
        },

		data() {
            return {
                min: 0,
                max: 0,
                rows: [],
				heightCss: {
					height: this.h + 'px'
				}
            }
        },

        watch: {
            data() {
                this.setMax()
                this.renderRows()
            }
        },

        methods: {
            setHeightCss: function(value){
                let percent = (value / this.max) * 100 + '%';
                return `height: ${percent}`
            },

            setBottomCss: function(value){
                let percent = (value / this.max) * 100 + 2 + '%';
				return `bottom: ${percent}`
			},

            setMax(){
                let values = [];
                this.data.map(function(item){
                    values.push(item.v)
                })

                this.max = Math.max.apply(null, values );

            },
            renderRows() {
                let interval
                let rows
                this.rows = []

                if(this.max/2 < 1){
                    interval = this.max / 2
                    rows = 2
                }else if(this.max/2 === 1){
                    interval = this.max / 3
                    rows = 3
                }else{
                    interval = this.max / 4
                    rows = 4
                }

                for(let i = rows; i > 1; i--){
                    this.rows.push(Math.floor(interval * i))
                }
                this.rows.push(0)
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';

</style>


